import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx={8}
      cy={8}
      r={7.75}
      fill="#fff !important"
      stroke="#C4C4C4"
      strokeWidth={0.5}
    />
    <mask
      id="a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={16}
      height={16}
    >
      <circle cx={8} cy={8} r={8} fill="#1D1D1D" />
    </mask>
    <g mask="url(#a)" fill={props.color?props.color:"#000"}>
      <path d="M-4-4H8V8H-4zM8 8h12v12H8z" />
    </g>
  </svg>
);

export default SvgComponent;
